import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/cliente.msg'

class ClientesService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('clientes', msg)
  }
}

export default new ClientesService()
